<template>
    <div class="d-flex flex-wrap justify-content-between align-items-center">
        <div class="btn-group domain-filter" role="group" aria-label="Goal domain filter">
            <button
                type="button"
                @click="setParentProp('goalDomainFilter', 0)"
                :style="
                    goalDomainFilter === 0
                        ? 'box-shadow: inset 0 -4px 0 0 #000000; color: black;'
                        : ''
                "
                class="btn btn-sm btn-light text-uppercase filter"
            >
                All
            </button>
            <button
                v-for="d in domains"
                type="button"
                @click="setParentProp('goalDomainFilter', d.id)"
                :style="
                    goalDomainFilter === d.id
                        ? `box-shadow: inset 0 -4px 0 0 ${d.color}; color: black;`
                        : ''
                "
                class="btn btn-sm btn-light text-uppercase filter"
            >
                {{ d.abbreviation }}
            </button>
        </div>
    </div>
</template>
<script>
export default {
    name: "GoalsDomainFilter",
    props: ["goalDomainFilter", "therapists", "domains"],
    data() {
        return {};
    },
    methods: {},
};
</script>

<style scoped lang="scss">
.filter {
    font-size: 0.45rem;
    font-weight: 500;
    border-radius: 0;
    background-color: #fcfcfc;
    color: #aeaeae;
}

@media screen and (min-width: 576px) {
    .filter {
        font-size: 0.7rem;
    }
}
</style>
